import { handleDownloadOnClick } from "@_common/downloadfile";
import { getValue } from "@utils/lodash";
import React from "react";
import { Modal } from "reactstrap";
import "./popup.scss";
import Notfound from "@components/Not-Found-small";
function DocumentPopup(props: any) {
  return (
    <Modal isOpen={getValue(props, `isOpen`, "")} toggle={props.toggle}>
      <div className="document-container">
        <div className="d-flex justify-content-between my-3">
          <h4>Documents</h4>
          <img src="/images/close-black.svg" onClick={() => props.toggle()} />
        </div>
        {getValue(props, `documentList.length`, 0) > 0
          ? getValue(props, `documentList`, []).map(
              (item: object, key: number) => {
                return (
                  <div
                    key={key}
                    className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                    // onClick={() =>
                    //   handleDownloadOnClick(
                    //     getValue(item, `url`, ""),
                    //     getValue(item, `name`, "")
                    //   )
                    // }
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src="/images/attach.svg"
                        className="img-fluid"
                        style={{ height: "20px", width: "20px" }}
                      />
                      <p className="cursor-pointer document_text">
                        {getValue(item, `name.length`, "") > 30
                          ? getValue(item, `name`, "")
                              .substring(0, 30)
                              .concat("...")
                          : getValue(item, `name`, "")}
                        {getValue(item, `extension`, "")}
                      </p>
                    </div>
                    {/* <img
                      src="/images/download.svg"
                      className="img-fluid"
                      style={{ height: "20px", width: "20px" }}
                    /> */}
                  </div>
                );
              }
            )
          : <Notfound />}
      </div>
    </Modal>
  );
}

export default DocumentPopup;
